import CartItem from '../components/cart/CartItem';
import ProductItem from '../components/product/ProductItem';
import { unitlessBreakpoints } from '../helpers';
import initCarousel from '../helpers/carousel';

const selectors = {
  cart: '[data-cart]',
  cartUpsells: '[data-cart-upsells]',
  cartIcon: '[data-cart-icon]',
  cartItem: '[data-cart-item]',
};

export default class MainCart {
  constructor(section) {
    this.el = section.el;
    this.cartUpsellSplide = null;
    this._init();
  }

  _init = () => {
    this.cart = this.el.querySelector(selectors.cart);
    this.cartIcon = document.querySelector(selectors.cartIcon);

    this.cart.addEventListener('submit', this._onDiscountFormSubmit);
    this._attachListeners();
  };

  _attachListeners = () => {
    const cartItems = this.cart.querySelectorAll(selectors.cartItem);
    cartItems.forEach(item => {
      new CartItem(item, this.updateCart);
    });

    const cartUpsells = this.cart.querySelector(selectors.cartUpsells);
    if (cartUpsells) {
      this.cartUpsellSplide = initCarousel(
        cartUpsells,
        {
          perPage: 1,
          gap: '0.5rem',
          padding: { right: '15%' },
        },
        true,
      );

      this.cartUpsellSplide = initCarousel(cartUpsells, {
        perPage: 2,
        pagination: false,
        arrows: true,
        gap: '0.5rem',
        padding: {
          right: 10,
        },
        breakpoints: {
          [unitlessBreakpoints.sm]: {
            gap: '1rem',
            padding: {
              right: 70,
            },
          },
          [unitlessBreakpoints.md]: {
            gap: '1rem',
            perPage: 3,
          },
          [unitlessBreakpoints.lg]: {
            perPage: 4,
            padding: {
              right: 36,
            },
          },
          [unitlessBreakpoints.xl]: {
            perPage: 5,
          },
        },
      });

      const productItems = cartUpsells.querySelectorAll('[data-product-item]');
      productItems.forEach(productItem => new ProductItem(productItem));
    }
  };

  _onDiscountFormSubmit = e => {
    const form = e.target.closest('[data-discount-form]');
    if (!form) {
      return;
    }

    e.preventDefault();
    const input = form.querySelector('[name="discount"]');
    const code = input?.value?.trim();
    if (code) {
      window.location.href = `${Shopify.routes.root}discount/${encodeURIComponent(code)}`;
    }
  };

  updateCart = res => {
    if (this.cartUpsellSplide) {
      this.cartUpsellSplide.destroy();
      this.cartUpsellSplide = null;
    }

    const responseText = res.sections['main-cart'];
    const mainHtml = new DOMParser().parseFromString(responseText, 'text/html');
    this.cart.innerHTML = mainHtml.querySelector(selectors.cart).innerHTML;

    const cartTrigger = res.sections['main-cart-trigger'];
    const triggerHtml = new DOMParser().parseFromString(
      cartTrigger,
      'text/html',
    );
    this.cartIcon.innerHTML = triggerHtml.querySelector(
      selectors.cartIcon,
    ).innerHTML;

    this._attachListeners();
  };
}
